import React from "react";
import ListItem from "./ListItem";
import "./Loading.css";
import logo from "../crypto-banner.png";

function Loading() {
  return (
    <div className="loading_container">
      <nav className="nav-wrapper appHeader">
        <div className="waves-effect btn-flat homeBtn">Home</div>
      </nav>
      <img src={logo} alt="logo" className="logo container" />
      <div className="lastUpdated time center">
        Last updated: mm/dd/yyyy, hh:mm:ss AM
      </div>
      <ul className="">
        <h3 className="header center">Top 10 Ranked Crypto Currencies</h3>
        <ListItem />
        <ListItem />
        <ListItem />
        <ListItem />
        <ListItem />
        <ListItem />
        <ListItem />
        <ListItem />
        <ListItem />
        <ListItem />
      </ul>
    </div>
  );
}

export default Loading;
